import * as Yup from 'yup';

export class CreateAreaValidator {
  public get schema() {
    return Yup.object().shape({
      code: Yup.string().required('Informe o código da área'),
      name: Yup.string().required('Informe o nome da área'),
      isDockManagement: Yup.boolean().required(),
    });
  }
}
